import { Component, Element, h } from '@stencil/core';
/**
 * @slot header - The header section takes slotted content mainly H tags. If the header is not supplied then the wholes section inlcuding the bottom border is omitted
 * @slot section-x - There are 5 sections that takes html content (eg section-1 section-2 etc). If a section is not supplied then the wholes section inlcuding the bottom border is omitted. Note the last section does not have a bottom border
 */
export class SegmentedContainerComponent {
  constructor() {
    this.hasHeader = false;
    this.hasSlot1 = false;
    this.hasSlot2 = false;
    this.hasSlot3 = false;
    this.hasSlot4 = false;
    this.hasSlot5 = false;
  }
  componentWillLoad() {
    this.hasHeader = !!this.hostElement.querySelector('[slot="header"]');
    this.hasSlot1 = !!this.hostElement.querySelector('[slot="section-1"]');
    this.hasSlot2 = !!this.hostElement.querySelector('[slot="section-2"]');
    this.hasSlot3 = !!this.hostElement.querySelector('[slot="section-3"]');
    this.hasSlot4 = !!this.hostElement.querySelector('[slot="section-4"]');
    this.hasSlot5 = !!this.hostElement.querySelector('[slot="section-5"]');
  }
  showHeader(show) {
    if (show) {
      return (h("div", { class: "container__header" },
        h("slot", { name: 'header' })));
    }
  }
  showSection(slotId, show) {
    if (show) {
      return (h("div", { class: "container__main-segmented" },
        h("slot", { name: 'section-' + slotId })));
    }
  }
  render() {
    return (h("div", { class: "container" },
      this.showHeader(this.hasHeader),
      h("div", { class: "container__main" },
        this.showSection('1', this.hasSlot1),
        this.showSection('2', this.hasSlot2),
        this.showSection('3', this.hasSlot3),
        this.showSection('4', this.hasSlot4),
        this.showSection('5', this.hasSlot5))));
  }
  static get is() { return "agl-ds-segmented-container"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["segmented-container.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["segmented-container.component.css"]
  }; }
  static get elementRef() { return "hostElement"; }
}
